import { GridLocaleText } from "@mui/x-data-grid";

import { translationService } from "../../services/translation/TranslationService";

const getLocalizationMapping = (
  itemTypeKey: string,
  noResultsMessageKey: string,
  customLocalizationMappings?: Partial<GridLocaleText>
): GridLocaleText => {
  const gridLocaleText = {
    noResultsOverlayLabel: noResultsMessageKey
      ? translationService.translate("general.list.no-items-matching-criteria", {
          itemType: itemTypeKey,
        })
      : translationService.translate("general.list.no-added-items", { itemType: itemTypeKey }),
    noRowsLabel: noResultsMessageKey
      ? translationService.translate(noResultsMessageKey)
      : translationService.translate("general.list.no-added-items", { itemType: itemTypeKey }),
    toolbarColumns: translationService.translate("general.data-grid.toolbarColumns"),
    columnsPanelTextFieldLabel: translationService.translate(
      "general.data-grid.columnsPanelTextFieldLabel"
    ),
    columnsPanelTextFieldPlaceholder: translationService.translate(
      "general.data-grid.columnsPanelTextFieldPlaceholder"
    ),
    checkboxSelectionHeaderName: translationService.translate(
      "general.data-grid.checkboxSelectionHeaderName"
    ),
    columnsPanelShowAllButton: translationService.translate(
      "general.data-grid.columnsPanelShowAllButton"
    ),
    columnsPanelHideAllButton: translationService.translate(
      "general.data-grid.columnsPanelHideAllButton"
    ),
    toolbarFilters: translationService.translate("general.data-grid.toolbarFilters"),
    toolbarFiltersTooltipHide: translationService.translate(
      "general.data-grid.toolbarFiltersTooltipHide"
    ),
    toolbarFiltersTooltipShow: translationService.translate(
      "general.data-grid.toolbarFiltersTooltipShow"
    ),
    filterPanelColumns: translationService.translate("general.data-grid.filterPanelColumns"),
    filterPanelOperator: translationService.translate("general.data-grid.filterPanelOperators"),
    filterPanelInputLabel: translationService.translate("general.data-grid.filterPanelInputLabel"),
    filterPanelInputPlaceholder: translationService.translate(
      "general.data-grid.filterPanelInputPlaceholder"
    ),
    filterPanelDeleteIconLabel: translationService.translate(
      "general.data-grid.filterPanelDeleteIconLabel"
    ),
    filterOperatorContains: translationService.translate(
      "general.data-grid.filterOperatorContains"
    ),
    filterOperatorEquals: translationService.translate("general.data-grid.filterOperatorEquals"),
    filterOperatorStartsWith: translationService.translate(
      "general.data-grid.filterOperatorStartsWith"
    ),
    filterOperatorEndsWith: translationService.translate(
      "general.data-grid.filterOperatorEndsWith"
    ),
    filterOperatorIs: translationService.translate("general.data-grid.filterOperatorIs"),
    filterOperatorNot: translationService.translate("general.data-grid.filterOperatorNot"),
    filterOperatorAfter: translationService.translate("general.data-grid.filterOperatorAfter"),
    filterOperatorOnOrAfter: translationService.translate(
      "general.data-grid.filterOperatorOnOrAfter"
    ),
    filterOperatorBefore: translationService.translate("general.data-grid.filterOperatorBefore"),
    filterOperatorOnOrBefore: translationService.translate(
      "general.data-grid.filterOperatorOnOrBefore"
    ),
    filterOperatorIsEmpty: translationService.translate("general.data-grid.filterOperatorIsEmpty"),
    filterOperatorIsNotEmpty: translationService.translate(
      "general.data-grid.filterOperatorIsNotEmpty"
    ),
    filterOperatorIsAnyOf: translationService.translate("general.data-grid.filterOperatorIsAnyOf"),
    toolbarFiltersTooltipActive: (count: number) =>
      translationService.translate("general.data-grid.toolbarFiltersTooltipActive", { count }),
    columnHeaderFiltersTooltipActive: (count: number) =>
      translationService.translate("general.data-grid.columnHeaderFiltersTooltipActive", { count }),
    columnHeaderFiltersLabel: translationService.translate(
      "general.data-grid.columnHeaderFiltersLabel"
    ),
    columnHeaderSortIconLabel: translationService.translate(
      "general.data-grid.columnHeaderSortIconLabel"
    ),
    footerRowSelected: (count: number) =>
      translationService.translate("general.data-grid.pagination.footerRowSelected", { count }),
    MuiTablePagination: {
      labelRowsPerPage: translationService.translate(
        "general.data-grid.pagination.labelRowsPerPage"
      ),
      labelDisplayedRows: (p) =>
        translationService.translate("general.data-grid.pagination.labelDisplayedRows", {
          from: p.from,
          to: p.to,
          count: p.count,
          page: p.page,
        }),
    },
    filterValueAny: translationService.translate("general.data-grid.filterValueAny"),
  } as GridLocaleText;

  if (customLocalizationMappings) {
    Object.keys(customLocalizationMappings).forEach((key) => {
      gridLocaleText[key] = customLocalizationMappings[key];
    });
  }

  return gridLocaleText;
};

export default getLocalizationMapping;
